import { ArgumentNullException } from '../../../../utility/exception/argument-null.exception';
import { PrimitiveValueObject } from '../../../../utility/model/primitive-value-object.model';

export class FeedbackKnowledgeLink extends PrimitiveValueObject<string> {
  static create(value: string): FeedbackKnowledgeLink {
    // if (value === null) {
    //   throw new ArgumentNullException();
    // }
    return new FeedbackKnowledgeLink(value);
  }
}
